import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditRowItemQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { PencilIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from './edit_form'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} />, icon: PencilIcon },
  ]

  const { data, loading } = useQuery<EditRowItemQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ loading || !data ? <Loading /> : data.rowItems.nodes[0].name }</div></DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
